import { gql } from '@apollo/client';

export const CONTRACTORS = gql`
  query Contractors {
    contractors {
      id
      name
      ceo
      logo
    }
  }
`;

export const CONTRACTOR = gql`
  query Contractors($id: ID!) {
    contractor(id: $id) {
      id
      name
      ceo
      phone
      email
      webSite
      about
      logo
      photos
      recommendedBy
      specifications
    }
  }
`;

export const CONTRACTOR_VIEW = gql`
  query Contractors($id: ID!) {
    contractor(id: $id) {
      id
      name
      ceo
      phone
      email
      webSite
      about
      logo
      photos
      recommendedBy
      specifications
      createdAt
      updatedAt
    }
  }
`;
